const membershipPlans = [
  {
    key: "Basic",
    name: "Básico",
    badge: "Precio de lanzamiento",
    price: 599,
    formattedPrice: "$599",
    period: "al mes",
    summary: "Ideal para iniciar tu vida fitness con guía clara y simple.",
    sections: [
      {
        title: "Entrenamiento",
        items: [
          "Acceso a rutina de entrenamiento de nivel simplificado, para iniciar tu vida fitness.",
        ],
      },
      {
        title: "Nutrición",
        items: ["Plan alimenticio y consulta 1-1 mensual."],
      },
      {
        title: "Mente",
        items: [
          "Acompañamiento motivacional a través de herramientas de difusión.",
        ],
      },
    ],
  },
  {
    key: "Silver",
    name: "Silver",
    badge: "Más elegido",
    price: 777,
    formattedPrice: "$777",
    period: "al mes",
    summary: "Para avanzar con un plan personalizado y herramientas de apoyo.",
    featured: true,
    sections: [
      {
        title: "Entrenamiento",
        items: ["Acceso a rutina de entrenamiento personalizada."],
      },
      {
        title: "Nutrición",
        items: [
          "Plan alimenticio con 2 opciones de menú, equivalencias y consulta 1-1 mensual.",
        ],
      },
      {
        title: "Mente",
        items: [
          "Guías de apoyo",
          "Meditación",
          "Diario de gratitud",
          "Calentamientos y estiramientos",
          "Organización de comidas",
          "Hábitos de autocuidado",
          "Journaling",
        ],
      },
      {
        title: "Beneficio adicional",
        items: ["20% off en seguimientos."],
      },
    ],
  },
  {
    key: "Gold",
    name: "Gold",
    badge: "Acompañamiento completo",
    price: 999,
    formattedPrice: "$999",
    period: "al mes",
    summary: "La experiencia más completa para sostener progreso y hábitos.",
    sections: [
      {
        title: "Entrenamiento",
        items: [
          "Acceso a rutina de entrenamiento personalizada con 1 videollamada de seguimiento para dudas.",
        ],
      },
      {
        title: "Nutrición",
        items: [
          "Plan alimenticio con 2 opciones de menú, equivalencias y consulta 1-1 cada 2 semanas.",
        ],
      },
      {
        title: "Mente",
        items: [
          "Guías de apoyo",
          "Meditación",
          "Diario de gratitud",
          "Calentamientos y estiramientos",
          "Organización de comidas",
          "Hábitos de autocuidado",
          "Journaling",
        ],
      },
      {
        title: "De regalo",
        items: [
          "Recetarios fit",
          "Retos semanales con checklist (4 semanas)",
          "Herramientas mindset fitness",
        ],
      },
      {
        title: "Beneficio adicional",
        items: ["20% off en seguimientos."],
      },
    ],
  },
];

export const getMembershipPlan = (planKey) =>
  membershipPlans.find((plan) => plan.key === planKey) || membershipPlans[0];

export const membershipPlanPrices = membershipPlans.reduce((acc, plan) => {
  acc[plan.key] = plan.price;
  return acc;
}, {});

export default membershipPlans;
